import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AreaItemPack } from '../../../booking/models/area-item-pack';
import { KioskStateService } from '../../services/kiosk-state.service';
import { KioskStateEnum } from '../../services/kiosk-state.enum';
import { AreaItem } from '../../../booking/models/area-item';
import { BookingOrderService } from '../../../booking/services/booking-order.service';
import { VisualItemInfo } from 'src/app/modules/general/models/visual-item-info';

@Component({
  selector: 'app-kiosk-main-page',
  templateUrl: './kiosk-main-page.component.html',
  styleUrls: ['./kiosk-main-page.component.css']
})
export class KioskMainPageComponent implements OnInit {

  registrationButton: AreaItemPack;

  constructor(
    private router: Router,
    private bookingOrderService: BookingOrderService,
    private kioskStateService: KioskStateService,
  ) {
  }

  ngOnInit(): void {
    // this.registrationButton = new AreaItemPack(-1, 'Registration', null, null, 'assets/svg/symbols/single.svg', false, null, '');
    this.kioskStateService.reset();
  }

  get buttons(): AreaItemPack[] {
    return null;
  }

  onAreaItemPackSelected(areaItemPack: AreaItemPack, selectedAreaItem: AreaItem = null) {
    switch (areaItemPack.id) {
      case -1:
        break;
      default:
        this.bookingOrderService.initializeOrderService(
          areaItemPack,
          selectedAreaItem,
        ).subscribe(
          result => {
            this.kioskStateService.update(KioskStateEnum.Birthday);
          }
        );
        break;
    }
  }

  get registrationButtonInfo(): VisualItemInfo {
    return new VisualItemInfo('Registration', () => {
      this.router.navigateByUrl('/kiosk/partner-registration');
    });
  }
}
